import React, {
  useState,
  useLayoutEffect,
  useRef,
  useContext,
  useCallback,
} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import { FormHelperText, Select, withStyles } from '@material-ui/core';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import MenuItem from '@material-ui/core/MenuItem';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import InputBase from '@material-ui/core/InputBase';
import Avatar from 'react-avatar';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Popover, PopoverBody } from 'reactstrap';
import {
  mdiMapMarker,
  mdiChatProcessingOutline,
  mdiCogs,
  mdiStethoscope,
  mdiTimelineCheck,
} from '@mdi/js';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@mdi/react';
import Badge from '@material-ui/core/Badge';
import schoolTermAxios from '../../../schooltermaxios';
import SmartContext from '../../App/context/SmartContext';
import {
  PERMISSION_ICONS_ARRAY,
  SCHOOL_DATA_KEY,
} from '../../../shared/utils/constants';
import PendencyInterval from '../../Utils/PendencyInterval';

function SideBarProfile(props) {
  const {
    t,
    loggedUser,
    listOfTerms,
    listOfOperation,
    listOfPermission,
    pendencySummary,
    collapsed,
  } = props;
  const [collapse, setCollapse] = useState(false);

  const context = useContext(SmartContext);
  const { toggleLoginOut } = context;
  const [popoverOpen, setPopoverOpen] = useState(false);

  let selectedTerm = useRef();

  const toggle = () => {
    setCollapse(!collapse);
  };

  const togglePopover = () => {
    setPopoverOpen(!popoverOpen);
  };

  const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(0),
      },
    },
    input: {
      position: 'relative',
      backgroundColor: '#fff',
      padding: '5px 0px 0px 11px',
      fontSize: 13,
      maxHeight: 33,
      fontFamily: ['Roboto', 'sans-serif'].join(','),
    },
  }))(InputBase);

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(2),
      marginTop: 15,
      minWidth: 190,
      height: 33,
      backgroundColor: '#fff',
      borderRadius: 3,
      border: '3px solid #fff',
    },
    selectEmpty: {
      marginTop: theme.spacing(0),
    },

    FormHelperText: {
      paddingLeft: 17,
    },

    Select: {
      maxWidth: 190,
      fontSize: 13,
      color: '#30313f',
      height: '2rem',
    },
  }));

  const handleChange = (event, target) => {
    selectedTerm = {
      co00Peri: target.props.value || loggedUser.selectedTermId,
      nomePeri: target.props.name || loggedUser.selectedTermName,
    };
    schoolTermAxios(selectedTerm);
  };

  const classes = useStyles();

  const menuItems = listOfTerms.map((item) => (
    <MenuItem
      className={classes.Select}
      key={item.id}
      value={item.id}
      name={item.name}
    >
      {item.name}
    </MenuItem>
  ));

  const filterMenuItems = menuItems.filter(
    (item) => item.props.value !== loggedUser.selectedTermId
  );

  const renderIconsByPermission = useCallback(() => {
    const operationsKeys = [];
    listOfPermission.forEach((p) => {
      if (p.children) {
        p.children.forEach((c) => operationsKeys.push(c.key));
      }
    });
    listOfOperation.forEach((o) => operationsKeys.push(o.key));
    if (operationsKeys) {
      const permissionIconsByUSer = [];
      operationsKeys.forEach((key) => {
        const content = PERMISSION_ICONS_ARRAY.find((item) => key === item.key);
        if (content) {
          permissionIconsByUSer.push(content);
        }
      });

      const permission = {};
      permissionIconsByUSer.forEach(({ key }) => {
        permission[key] = key;
      });
      return (
        <PendencyInterval>
          <div className="sidebar-icons">
            {permission.COMUMENS && (
              <NavLink to="/minime/chat">
                <IconButton>
                  <Badge
                    badgeContent={pendencySummary.unreadChatMessages}
                    color="error"
                  >
                    <Icon
                      path={mdiChatProcessingOutline}
                      horizontal
                      vertical
                      rotate={180}
                      size={0.81}
                      color="#FFFFFF"
                    />
                  </Badge>
                </IconButton>
              </NavLink>
            )}
            {permission.DIA_APME && (
              <NavLink to="/minime/aplicacao-medicamento">
                <IconButton>
                  <Badge
                    badgeContent={pendencySummary.totalMedicalPendencyQuantity}
                    color="error"
                  >
                    <Icon
                      path={mdiStethoscope}
                      horizontal
                      vertical
                      size={0.81}
                      rotate={180}
                      color="#FFFFFF"
                      id="mdiStethoscope"
                    />
                  </Badge>
                </IconButton>
              </NavLink>
            )}
            {permission.DIA_PICK && (
              <NavLink to="/minime/smartgo">
                <IconButton>
                  <Badge
                    badgeContent={pendencySummary.smartGoPendency}
                    color="error"
                  >
                    <Icon
                      path={mdiMapMarker}
                      horizontal
                      vertical
                      size={0.81}
                      rotate={180}
                      color="#FFFFFF"
                      id="mdiStethoscope"
                    />
                  </Badge>
                </IconButton>
              </NavLink>
            )}
            <NavLink to="/minime/auditoria">
              <IconButton>
                <Badge
                  badgeContent={
                    pendencySummary.communicationPendency +
                    pendencySummary.routineRecordsPendency
                  }
                  color="error"
                >
                  <Icon
                    path={mdiTimelineCheck}
                    horizontal
                    vertical
                    size={0.81}
                    rotate={180}
                    color="#FFFFFF"
                    id="mdiTimelineCheck"
                  />
                </Badge>
              </IconButton>
            </NavLink>
            <NavLink to="/minime/controlpanel">
              <IconButton>
                <Icon
                  path={mdiCogs}
                  horizontal
                  vertical
                  size={1}
                  color="#FFFFFF"
                />
              </IconButton>
            </NavLink>
          </div>
        </PendencyInterval>
      );
    }
    return null;
  }, [listOfPermission, pendencySummary]);

  const showSchoolData = () => {
    return listOfOperation.some(
      (operation) => operation.key === SCHOOL_DATA_KEY
    );
  };

  useLayoutEffect(() => {
    toggle();
    selectedTerm.current = {
      co00Peri: loggedUser.selectedTermId,
      nomePeri: loggedUser.selectedTermName,
    };
  }, [loggedUser]);

  useLayoutEffect(() => {
    if (popoverOpen) {
      setPopoverOpen(!popoverOpen);
    }
  }, [collapsed]);

  return (
    <div
      className={
        !collapsed ? 'sidebar-profilebar--collapsed' : 'sidebar-profilebar'
      }
    >
      {renderIconsByPermission()}
      <div className=" sidebar-profile">
        {showSchoolData() && (
          <div className="sidebar-comboboxes">
            <Link className="schoolName" to="/minime/dados-escola">
              {loggedUser.clientName}
            </Link>
          </div>
        )}
        <div>
          <FormControl
            variant="outlined"
            id="form-control-collapsed"
            className={classes.formControl}
          >
            <Select
              labelId="demo-customized-select-label"
              id="demo-customized-select"
              inputProps={{
                'aria-label': 'Without label',
              }}
              onChange={handleChange}
              value={selectedTerm.co00Peri}
              displayEmpty
              input={<BootstrapInput />}
              className={classes.Select}
            >
              <FormHelperText className={classes.FormHelperText} disabled>
                {loggedUser.selectedTermName}
              </FormHelperText>
              {filterMenuItems}
            </Select>
          </FormControl>
        </div>
      </div>
      <div id="popover-logout" className="sidebar__content">
        <ul className="sidebar__block">
          <div>
            <span className="sidebar__avatar-icon">
              <Avatar
                size="24px"
                round="12px"
                name={loggedUser.name}
                maxInitials={2}
                src={loggedUser.photoUrl}
              />
            </span>
            <span
              className={
                !collapsed
                  ? 'sidebar-profile-username--collapse'
                  : 'sidebar-profile-username'
              }
            >
              <p className="sidebar-username">{loggedUser.name}</p>
            </span>
            <Popover
              placement="left"
              target="popover-logout"
              className="smart-popover"
              isOpen={popoverOpen}
              toggle={togglePopover}
            >
              <PopoverBody>
                <button
                  type="button"
                  className="popover-button"
                  onClick={() => {
                    togglePopover();
                    toggleLoginOut();
                  }}
                >
                  <MuiThemeProvider>
                    <ExitToAppIcon />
                  </MuiThemeProvider>
                  <span className="form__form-group-label">
                    {t('general.exit')}
                  </span>
                </button>
              </PopoverBody>
            </Popover>
          </div>
        </ul>
      </div>
    </div>
  );
}

SideBarProfile.propTypes = {
  t: PropTypes.func.isRequired,
  loggedUser: PropTypes.shape().isRequired,
  listOfTerms: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  listOfOperation: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  listOfPermission: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  collapsed: PropTypes.bool.isRequired,
  pendencySummary: PropTypes.shape(PropTypes.shape).isRequired,
};

SideBarProfile.defaultProps = {
  listOfPermission: [],
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
    pendencySummary: state.pendencySummary,
    listOfTerms: state.listOfTerms.listOfTerms,
  }))(SideBarProfile)
);
